import React, { FC, useState } from "react";
import ButtonComponent from "../../../shared/components/ButtonComponent";

import { DownloadOutlined } from "@ant-design/icons";
import DashboardService from "../../../services/DashboardService/dashboard.service";
import DashboardLoginReportFilter from "../DashboardLoginReportFilter";
import "./downloadLoginReport.scss";
import { serialize } from "serializr";
import { DashboardFilterModel } from "../../../models/DashboardModel/DashboardFilterModel/dashboardFilter.model";
import TableComponent from "../../../shared/components/TableComponent";

interface DownlaodLoginReportProps {
   type: 'tutor' | 'student';
   setReportFilters?: Function;
}

const DownlaodLoginReport: FC<DownlaodLoginReportProps> = (props) => {
    const { type, setReportFilters } = props;
    const [filters, setFilters] = useState<DashboardFilterModel>({});
    const [loading, setLoading] = useState(false);

    const download = (blob) => {
        // Create blob link to download
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
        'download',
        `${type === 'student' ? "Student" : "Tutor " } Login Report.csv`,
        );

        // Append to html link element page
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        link.parentNode?.removeChild(link);
    }
    const handleDownload = (filters) => {
        setLoading(true)

        if (type === 'student') {
            DashboardService.fetchLoginReport(
                serialize(DashboardFilterModel, filters ?? {}),
                (blob) => { download(blob) },
                () => { },
                () => { setLoading(false) }
            );
        } else if (type === 'tutor') {
            DashboardService.fetchTutorLoginReport(
                serialize(DashboardFilterModel, filters ?? {}),
                (blob) => { download(blob)},
                () => { },
                () => { setLoading(false) }
            );
        }

    }
    return (
        <>
            <div className="download-report-row">
                <div className="filter-row">
                    Download Report Filter
                    <DashboardLoginReportFilter
                        applyHandler={(values) => {
                            setFilters(values)
                            setReportFilters && setReportFilters(values);
                        }}
                        clearHandler={() => {
                            setFilters({})
                        }}
                    />
                </div>
                <ButtonComponent
                    disabled={loading}
                    type="text"
                    iconLeft={<DownloadOutlined />}
                    buttonContent="Downlaod Login Report"
                    onClick={() => handleDownload(filters)}
                />
            </div>
        </>
    )
}

export default DownlaodLoginReport;
